import React from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Collapse,
  IconButton,
  Paper,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { ArrowDropDown as ArrowDropDownIcon, Close } from "@material-ui/icons";

const ReassignResultComponent = ({ result, onClose }) => (
  <>
    <Dialog
      open={!!result}
      onClose={onClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "1rem",
        }}
      >
        <DialogTitle id="scroll-dialog-title">Assign Result</DialogTitle>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent
        dividers
        style={{ backgroundColor: "#f3f3f3", maxHeight: "70vh" }}
      >
        <Box display="flex" justifyContent="space-between" mb={2} gap={2}>
          <Box flex={1}>
            <Paper>
              <Box p={2}>
                <Typography variant="body1" fontWeight="bold">
                  Total Assigned:{" "}
                  {result && result.total_assigned ? result.total_assigned : 0}
                </Typography>
              </Box>
            </Paper>
          </Box>
          <Box flex={1}>
            <Paper>
              <Box p={2}>
                <Typography variant="body1" fontWeight="bold">
                  Total Reassigned:{" "}
                  {result && result.total_reassigned
                    ? result.total_reassigned
                    : 0}
                </Typography>
              </Box>
            </Paper>
          </Box>
        </Box>
        {!!result && !!result.failed_validate.length && (
          <>
            <Box py={1}>
              <Divider />
            </Box>
            <Box mt={2}>
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Unprocessed Items
                </Typography>
              </Box>
              <Box>
                {result.failed_validate.map((r, i) => (
                  <Box key={i} mt={1}>
                    <Accordion>
                      <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
                        <Typography variant="body1" fontWeight="bold">
                          {r.status === "scanned"
                            ? "Code has been scanned by Consumer"
                            : "Code has Stock Activity"}{" "}
                          <span
                            style={{
                              color: r.codes.length > 0 ? "red" : "black",
                            }}
                          >
                            ({r.codes.length})
                          </span>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box maxHeight={350} overflow="auto">
                          {r.codes.map((code) => (
                            <Box pb={0.5}>
                              <Typography>{code}</Typography>
                            </Box>
                          ))}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                ))}
              </Box>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  </>
);

export default ReassignResultComponent;
